import { useEffect, useRef } from 'react'
import { useProfessional } from '../../../context/ProfessionalContext'
import Notes from '../../Professional/Detail/Tabs/Notes'
import { useAuth } from '../../../context/AuthContext'

export default function OpenNotes() {
    const { user } = useAuth()
    const { detail, getProfessional } = useProfessional()
    const hasFetched = useRef(false)

    useEffect(() => {
        if (user?.userID && !hasFetched.current) {
            hasFetched.current = true
            getProfessional(String(user.userID))
        }
    }, [user?.userID])

    if (!detail) {
        return (
            <div className='grid h-full min-h-[360px] animate-pulse place-items-center rounded-2xl border border-gray-200 bg-white dark:border-gray-700 dark:bg-white/[0.03]'>
                <p className='text-sm text-gray-500 dark:text-gray-400'>Carregando notas...</p>
            </div>
        )
    }

    return (
        <div className='h-full dark:text-gray-200'>
            <Notes
                title='Minhas notas abertas'
                status={0}
                showTitle={false}
                cardClassName='flex h-full flex-col overflow-hidden'
                bodyClassName='custom-scrollbar min-h-0 flex-1 overflow-y-auto'
            />
        </div>
    )
}
